// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"451":"a821848c","706":"6b2a48cc"}[chunkId] + ".css";
};